import React, { ReactElement } from "react";
import classNames from "classnames";
import { ToolbarListProps } from "./toolbar-list.types";

export const ToolbarList = ({
  children,
  className,
  checkboxes,
  ...rest
}: ToolbarListProps): ReactElement => (
  <ul
    className={classNames(
      "spark-toolbar__list",
      { "spark-toolbar__list--checkboxes": checkboxes },
      className
    )}
    role={checkboxes ? "menu" : undefined}
    {...rest}
  >
    {checkboxes
      ? React.Children.map(children, (child) => {
          return React.isValidElement(child)
            ? React.cloneElement(child as ReactElement, {
                role: "menuitem",
              })
            : null;
        })
      : children}
  </ul>
);

ToolbarList.displayName = "ToolbarList";
